import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/ui/button";
import { Input } from "@/ui/input";
import { Badge } from "@/ui/badge";
import { Skeleton } from "@/ui/skeleton";
import { DataTable } from "@/components/DataTable";
import { EmptyState } from "@/components/EmptyState";
import { PageHeader } from "@/components/PageHeader";
import { MoneyInput } from "@/components/MoneyInput";
import { DateRangePicker } from "@/components/DateRangePicker";
import { useState } from "react";

export const Route = createFileRoute("/_dev/components")({
  component: ComponentsDemo,
});

function ComponentsDemo() {
  const [money, setMoney] = useState<number | null>(null);
  const [range, setRange] = useState<{ from?: Date; to?: Date }>({});
  return (
    <div className="space-y-8 p-8" data-testid="components-demo">
      <PageHeader title="Components" description="Visual baseline cho design system" />
      <section className="flex flex-wrap gap-2">
        <Button>Primary</Button>
        <Button variant="secondary">Secondary</Button>
        <Button variant="outline">Outline</Button>
        <Button variant="ghost">Ghost</Button>
        <Button variant="destructive">Destructive</Button>
      </section>
      <section className="grid max-w-md gap-3">
        <Input placeholder="Text input" />
        <MoneyInput value={money} onChange={setMoney} />
        <DateRangePicker value={range} onChange={setRange} />
      </section>
      <section className="flex gap-2">
        <Badge>Default</Badge>
        <Badge variant="secondary">Secondary</Badge>
        <Badge variant="outline">Outline</Badge>
        <Badge variant="destructive">Danger</Badge>
      </section>
      <section className="grid gap-2">
        <Skeleton className="h-4 w-48" />
        <Skeleton className="h-4 w-64" />
      </section>
      <section>
        <DataTable
          columns={[
            { accessorKey: "name", header: "Tên" },
            { accessorKey: "qty", header: "SL" },
          ]}
          data={[
            { name: "Áo dài", qty: 2 },
            { name: "Yếm", qty: 5 },
          ]}
        />
      </section>
      <section>
        <EmptyState title="Chưa có dữ liệu" description="Bắt đầu bằng cách tạo mới." />
      </section>
    </div>
  );
}
